// @flow
import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import type { Node } from 'react';

type Context = $ReadOnly<{
    interval: number,
    now: number
}>;

const ClockContext = createContext<Context>({});

type Props = $ReadOnly<{
    interval?: number,
    children: Node
}>;
export const ClockProvider = ({ interval = 1000, children }: Props) => {
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        const intervalId = setInterval(() => setNow(Date.now()), interval);

        return () => {
            clearInterval(intervalId);
        };
    }, [interval]);

    const context = {
        interval,
        now
    };

    return (
        <ClockContext.Provider value={context}>
            {children}
        </ClockContext.Provider>
    );
};

const useClockContext = () => useContext(ClockContext);


export default function useNow(interval?: number, disabled?: boolean) {
    const context = useClockContext();
    const [now, setNow] = useState(context.now);
    const timerRef = useRef(interval || 0);

    if(disabled) {
        return null;
    }

    if(typeof interval === 'undefined') {
        return context.now;
    }

    const newTimer = timerRef.current - context.interval;

    if(newTimer <= 0) {
        setNow(context.now);
        timerRef.current = interval;
        return context.now;
    }
    else {
        timerRef.current = newTimer;
        return now;
    }
}